export default "<div [hidden]=\"!isLoading\" class=\"ion-text-center\">\r\n    <ion-spinner></ion-spinner> <span>{{ message }}</span>\r\n</div>";